
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

@Component({
  name: 'PieChart',
})
export default class PieChart extends Vue {
  @Prop({ required: true })
  planned!: number
  @Prop({ required: true })
  unplanned!: number
  @Prop({ required: true })
  open!: number
  @Prop({ required: true })
  inProgress!: number

  chart: any;

  mounted(): void {
    this.disposeChart();
    this.initChart();
  }

  updated(): void {
    this.disposeChart();
    this.initChart();
  }

  beforeDestroy(): void {
    this.disposeChart();
  }

  private initChart(): void {
    // Create chart instance
    this.chart = am4core.create(this.$refs.container as HTMLElement, am4charts.PieChart);

    // Add data
    this.chart.data = [{
      "type": this.$t('dashboard.activityStatusSumsTable.pie.planned'),
      "amount": this.planned,
      "color": "#33cc66",
    }, {
      "type": this.$t('dashboard.activityStatusSumsTable.pie.unplanned'),
      "amount": this.unplanned,
      "color": "#ff6633",
      // }, {
      //   "type": "Offen",
      //   "amount": this.open,
      //   "color": "red",
      // }, {
      //   "type": "In Bearbeitung",
      //   "amount": this.inProgress,
      //   "color": "orange",
    }];

    // Let's cut a hole in our Pie chart the size of 20% the radius
    this.chart.innerRadius = am4core.percent(50);

    // Add and configure Series
    const pieSeries = this.chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "amount";
    pieSeries.dataFields.category = "type";

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;
    pieSeries.slices.template.propertyFields.fill = "color";

    // Disable ticks and labels
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;


    const hs = pieSeries.slices.template.states.getKey("hover")!;
    hs.properties.scale = 1.1;
    hs.properties.fillOpacity = 0.5;
  }

  private disposeChart(): void {
    if (this.chart !== undefined)
      this.chart.dispose();
  }

  @Watch('planned')
  @Watch('unplanned')
  @Watch('open')
  @Watch('inProgress')
  private onPropChanged() {
    this.disposeChart();
    this.initChart();
  }
}
